<template>
    <div>
      <!-- Use ref attribute to create a reference Vue can access -->
      <div v-if="dataIsLoaded">
        <canvas class="chartCanvas" ref="chartCanvas"></canvas>
     </div>
    </div>
  </template>
  
  <script>
  import { Chart, registerables } from 'chart.js';
  Chart.register(...registerables);
  
  export default {
    name: 'AssessmentChart',
    props: ['assessments'], // Expecting assessments data to be passed as a prop
    data() {
      return {
        chartInstance: null, // Store the chart instance here
        dataIsLoaded: false
      };
    },
    computed: {
        chartData() {
            return this.assessments.map(a => ({
                name: a.name,
                correct: a.correct,
                totalQuestions: a.totalQuestions,
            }));
        }
    },
    watch: {
      // Watcher for the assessments prop
      assessments: {
        handler(newVal, oldVal) {
          // Use nextTick to ensure DOM updates have been applied
          this.$nextTick(() => {
            this.renderChart();
            this.dataIsLoaded = true;
          });
        },
        deep: true, // Watch for deep changes within the object
        immediate: true, // Trigger handler immediately with current value
      },
    },
    mounted() {
      this.renderChart(); // Initial chart rendering
    },
    methods: {
      renderChart() {
        this.$nextTick(() => {
            if (!this.$refs.chartCanvas) return;

            const ctx = this.$refs.chartCanvas.getContext('2d');
            // Chart.js setup and instantiation goes here
        });


        // Ensure the chartCanvas ref is defined and the canvas element is available
        if (!this.$refs.chartCanvas) {
          return; // Exit if the canvas is not yet available
        }
  
        // If there's an existing chart instance, destroy it before creating a new one
        if (this.chartInstance) {
          this.chartInstance.destroy();
        }
  
        const ctx = this.$refs.chartCanvas.getContext('2d');
        const labels = this.assessments.map(a => a.name);
        const lastnames = this.assessments.map(a => a.candidateLastName);
        const correctAnswers = this.assessments.map(a => a.correct);
        const incorrectAnswers = this.assessments.map(a => a.totalQuestions - a.correct);
        const totalQuestions = this.assessments.map(a => a.totalQuestions);       
  
        const data = {
          labels: labels,
          datasets: [{
            label: 'Correct Answers',
            data: correctAnswers,
            backgroundColor: 'rgba(141, 255, 205, 0.2)',
            borderColor: 'rgba(188, 255, 219, 1)',
            borderWidth: 1
          }, 
          {
            label: 'Incorrect Answers',
            data: incorrectAnswers,
            backgroundColor: 'rgba(216, 0, 50, 0.2)',
            borderColor: 'rgba(239, 35, 60, 1)',
            borderWidth: 1
          },
          {
            label: 'Total Questions',
            data: totalQuestions,
            backgroundColor: 'rgba(83, 89, 154, 0.2)',
            borderColor: 'rgba(109, 157, 197, 1)',
            borderWidth: 1
          }]
        };

        const additionalTextPlugin = {
            id: 'additionalTextPlugin',
            afterDraw: (chart) => {
            const ctx = chart.ctx;
            ctx.save();
            ctx.font = "12px Arial"; // Customize as needed
            ctx.textAlign = 'center';
            ctx.fillStyle = '#666'; // Text color
            
            chart.data.labels.forEach((label, index) => {
                const meta = chart.getDatasetMeta(0); // Assuming you want to align with the first dataset
                const x = meta.data[index].x;
                const y = chart.chartArea.bottom + 10; // Adjust as needed
                
                // Draw the label (name)
                //ctx.fillText(label, x, y);

                // Draw the date below the label
                const lnames = lastnames[index]; // Get the corresponding date
                ctx.fillText(lnames, x+30, y); // Adjust y position to draw below the label
            });
            
            ctx.restore();
            }
        };
  
        const config = {
          type: 'bar',
          data: data,
          options: {
            responsive: true,
            scales: {
              y: {
                beginAtZero: true
              }
            }
          },
          plugins:  [
            additionalTextPlugin,
          ]
        };
  
        // Create a new chart instance
        this.chartInstance = new Chart(ctx, config);
        this.chartInstance.height = 500;
      },
    },
  };
  </script>
<style scoped>
@media screen and (max-width: 576px) {
  .chartCanvas {
    max-width: 300px;
  }
}
</style>